//#region Imports
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
//#endregion Imports
@Injectable({
  providedIn: 'root'
})
export class NavigationService {
    //#region Public Variables
    private IgnoreCanDeactivate: boolean = false;
    //#endregion Public Variables

    //#region Constructor
    constructor(
        private router: Router
    ){}
    //#endregion Constructor

    //#region Public Methods
    public SetIgnoreCanDeactivate(ignore: boolean) : void {
        this.IgnoreCanDeactivate = ignore;
    }

    public GetIgnoreCanDeactivate(): boolean {
        return this.IgnoreCanDeactivate;
    }

    public NavigateTo(url: string) : void {
        this.SetIgnoreCanDeactivate(true);

        this.router.navigate([url]).then(()=> {
            this.SetIgnoreCanDeactivate(false);
        });
    }

    public NavigateByUrl(url: string) : void {
        this.SetIgnoreCanDeactivate(true);

        this.router.navigateByUrl(url).then(()=> {
            this.SetIgnoreCanDeactivate(false);
        });
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
